export default __webpack_public_path__ + "1ff758da7d93685319874111dec6a6f7.png";